module.exports = require("react-immutable-proptypes");


//////////////////
// WEBPACK FOOTER
// external "react-immutable-proptypes"
// module id = 8
// module chunks = 0